const isPreferredTimeFilterActive = (timeFilters) => Object.values(timeFilters).some((value) => value);
export {
  isPreferredTimeFilterActive
};
//# sourceMappingURL=is-preferred-time-filter-active.js.map
